module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mex-asset-preview"
  }, [_c('div', [_c('Button', {
    attrs: {
      "size": "small",
      "loading": _vm.uploading
    },
    on: {
      "click": _vm.pick
    }
  }, [_vm._v("上传到七牛")]), _vm._v(" "), _c('input', {
    ref: "file",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": _vm.accept
    },
    on: {
      "change": _vm.onFile
    }
  })], 1), _vm._v(" "), (_vm.url) ? _c('p', {
    staticClass: "mex-dim-hint"
  }, [_vm._v(_vm._s(_vm.url))]) : _vm._e(), _vm._v(" "), (_vm.url && _vm.kind === 'image') ? _c('img', {
    staticClass: "mex-asset-preview-img",
    attrs: {
      "src": _vm.url
    }
  }) : (_vm.url && _vm.kind === 'audio') ? _c('audio', {
    staticClass: "mex-asset-preview-audio",
    attrs: {
      "src": _vm.url,
      "controls": ""
    }
  }) : (_vm.url && _vm.kind === 'video') ? _c('video', {
    staticClass: "mex-asset-preview-video",
    attrs: {
      "src": _vm.url,
      "controls": ""
    }
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-54a1ee56","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/mex/MexAssetPreview.vue
// module id = 1818
// module chunks = 8